export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-mountains-3a9ae494e577148eaaddad1d69e56e5e.svg";